import { defineComponent as _defineComponent } from 'vue'
import { Fn, useEventListener } from '@vueuse/core'
import { Portal } from 'portal-vue'
import { computed, ref, watch } from 'vue'

interface SlideOverProps {
  value: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideOver',
  props: {
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  value: boolean
};




const slideoverContentRef = ref<HTMLDivElement | null>(null)
const isOpen = computed({
  get: () => props.value,
  set: (value: boolean) => {
    emits('input', value)
  },
})

let cleanUpKeydownListener: Fn | null = null
watch(
  () => props.value,
  (newIsOpen) => {
    if (newIsOpen) {
      cleanUpKeydownListener = useEventListener('keydown', (event) => {
        if (!isOpen.value || event.defaultPrevented || event.key !== 'Escape') {
          return
        }

        event.preventDefault()
        event.stopPropagation()
        isOpen.value = false
      })

      // Focus the slideover content so the user can navigate with the keyboard
      // and the tab focus is not behind the slideover
      setTimeout(() => {
        slideoverContentRef.value?.focus()
      }, 0)
    } else {
      cleanUpKeydownListener?.()
      cleanUpKeydownListener = null
    }
  },
)

return { __sfc: true,props, emits, slideoverContentRef, isOpen, cleanUpKeydownListener, Portal }
}

})